import React from 'react';
import { Container } from '@material-ui/core';
import useEagerConnect from '../../hooks/useEagerConnect';

import Nav from '../Nav';
import styled from 'styled-components';
import FooterV2 from '../FooterV2';
import { Divide } from 'react-feather';
import Nav2 from '../Nav/Nav2';

interface PageV3Props {
  children?: React.ReactNode;
}
const Page: React.FC<PageV3Props> = ({ children }) => {
  useEagerConnect();
  return (
    <body className="antialiased">
      <div className="antialiased flex flex-col min-h-full __className_fbe417">
        <Nav2 />
        {children}
        <FooterV2 />
      </div>
    </body>
  );
};

export default Page;
